import useSWR from 'swr';
import { fetcher } from '../base';

export const cartCountEndpoint = '/cart/count';

export const useCartCount = () => useSWR(cartCountEndpoint, fetcher);
